<app-module-header [icon]="'garage_home'"
  [title]="organization.organizationName + ' - ' + ('CHECKIN_CHECKOUT.PARKINGS_CHECKIN_CHECKOUT' | transloco) + ' - Data - ' + (lastReloadData | date: 'HH:mm:ss') + (organization.organizationId == 'dc3e5c36-a4f7-4886-98f2-4833ea27f84b' ? ' - Skavsta: ' + (lastReloadkavstaBatch| date: 'HH:mm:ss') : '')"></app-module-header>

@if (isLoading) {
<mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<div class="filter-bar">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'ORDER_DETAILS.PARKING_SERVICE.STATUS' | transloco }}</mat-label>
    <mat-select [(ngModel)]="selectedFilter" (selectionChange)="applyFilter()">
      <mat-option value="all">{{ 'CHECKIN_CHECKOUT.FILTER_OPTIONS.ALL' | transloco }}</mat-option>
      <mat-option value="delayed">{{ 'CHECKIN_CHECKOUT.FILTER_OPTIONS.DELAYED' | transloco }}</mat-option>
      <mat-option value="upcoming">{{ 'CHECKIN_CHECKOUT.FILTER_OPTIONS.UPCOMING' | transloco }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{ 'PLACEHOLDER.PARKING' | transloco }}</mat-label>
    <mat-select [(ngModel)]="selectedParkingFilter" (selectionChange)="applyFilter()">
      <mat-option value="all">All</mat-option>
      @for (parking of parkingFilterOptions; track parking) {
      <mat-option [value]="parking.value">
        {{ parking.label }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="col">
  <div class="col1">
    <div class="colheader">
      <mat-icon class="icon-bottom">flight_takeoff</mat-icon>{{ 'CHECKIN_CHECKOUT.CHECK_INS' | transloco }}:
      {{dataSourceCheckIn.data.length}}
    </div>
    <table mat-table matSort [dataSource]="dataSourceCheckIn.data.length >0 ? dataSourceCheckIn : emptyDataCheckIn"
      #sortCheckIn="matSort">
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.ORDER_NUMBER' | transloco }}</th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>

      <ng-container matColumnDef="parkingFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.PARKING_FROM' | transloco }}</th>
        <td mat-cell *matCellDef="let order">{{order.parkingFrom | date:'yyyy-MM-dd HH:mm'}}</td>
      </ng-container>

      <ng-container matColumnDef="carId">
        <th mat-header-cell *matHeaderCellDef>Registration#</th>
        <td mat-cell *matCellDef="let order">{{order.carId}}</td>
      </ng-container>

      <ng-container matColumnDef="parkingSiteName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.PARKING' | transloco }}</th>
        <td mat-cell *matCellDef="let order"
          [ngStyle]="{'color': order.parkingSiteName?.includes('FP2') ? 'red' : 'inherit'}">
          {{order.parkingSiteName}}</td>
      </ng-container>

      <ng-container matColumnDef="empty-row">
        <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsCheckIn"></tr>
      <tr mat-row
        *matRowDef="let row; columns: dataSourceCheckIn.data.length > 0  ? displayedColumnsCheckIn : ['empty-row'];"
        (click)="goToOrder(row)" class="clickable" [ngClass]="{'delayed': row.status === 'Delayed'}">
      </tr>

    </table>
  </div>
  <div class="col2">
    <div class="colheader">
      <mat-icon class="icon-bottom">flight_land</mat-icon>{{ 'CHECKIN_CHECKOUT.CHECK_OUTS' | transloco }}:
      {{dataSourceCheckOut.data?.length}}
    </div>

    <table mat-table matSort [dataSource]="dataSourceCheckOut.data?.length > 0 ? dataSourceCheckOut : emptyDataCheckOut"
      #sortCheckOut="matSort">
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.ORDER_NUMBER' | transloco }}</th>
        <td mat-cell *matCellDef="let order">{{order.orderNr}}</td>
      </ng-container>

      <ng-container matColumnDef="parkingTo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.PARKING_TO' | transloco }}</th>
        <td mat-cell *matCellDef="let order">{{order.parkingTo | date:'yyyy-MM-dd HH:mm'}}</td>
      </ng-container>

      <ng-container matColumnDef="carId">
        <th mat-header-cell *matHeaderCellDef>Registration#</th>
        <td mat-cell *matCellDef="let order">{{order.carId}}</td>
      </ng-container>

      <ng-container matColumnDef="parkingSiteName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'CHECKIN_CHECKOUT.PARKING' | transloco }}</th>
        <td mat-cell *matCellDef="let order"
          [ngStyle]="{'color': order.parkingSiteName?.includes('FP2') ? 'red' : 'inherit'}">
          {{order.parkingSiteName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="empty-row">
        <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsCheckOut"></tr>
      <tr mat-row
        *matRowDef="let row; columns: dataSourceCheckOut.data.length > 0 ? displayedColumnsCheckOut : ['empty-row'];"
        (click)="goToOrder(row)" class="clickable" [ngClass]="{'delayed': row.status === 'Delayed'}">
      </tr>

    </table>
  </div>
</div>